import I18n from 'i18n-js';

export default function generateTextData(keyText, data) {
  return Object.assign({}, ...data.map((key) => ({
    [key]: I18n.t(`${keyText}.${key}`),
  })));
}
